import { isCreatedByMe, resourceCreatorName } from '../../../components/only-mine-filter'
import React, { useContext, useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import CircularProgress from '@material-ui/core/CircularProgress'

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`

const TableTitle = styled.h2`
  padding-bottom: 16px;
  margin: 0 auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`

const Description = styled.p`
  margin: 0 0 16px;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.4;
`

const TableContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`

const TableHead = styled.thead`
  color: #FFF;
`

const TableBody = styled.tbody`
`

const TableHeadRow = styled.tr`
`

const TableBodyRow = styled.tr`
  cursor: pointer;
  &:hover {
    background: #f2f2f2;
  }
`

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${props => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${props => (props.bigWidth) ? '160px' : '100px' };
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${props => props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
`

const CampaignTable = (props) => {
  const { user, updateUser } = useContext(AuthContext)
  const { onlyMine = false } = props
  const visibleCampaigns = (props.campaigns || []).filter((entry) => !onlyMine || isCreatedByMe(entry, user))
  const { openSnackbar } = useContext(DashboardContext)

  const handleClick = (campaign) => {
    props.history.push('/dashboard/campaign/' + campaign.id)
  }

  return props.campaignsState !== 2 ? (
    <Container>
      <CircularProgress size={32} />
    </Container>
  ) : (
    <Container>
      <TableTitle>Found {visibleCampaigns.length} campaign(s)</TableTitle>
      <Description>
        Campaigns send a series of messages to selected clients over time. Create a campaign, add message steps, and choose when each message is sent.
      </Description>
      <TableContainer>
        <Table>
          <TableHead>
            <TableHeadRow>
              <HeadCell>Campaign ID</HeadCell>
              <HeadCell>Name</HeadCell>
              <HeadCell>Created by</HeadCell>
              <HeadCell># Steps</HeadCell>
              <HeadCell># Recipients</HeadCell>
              <HeadCell>State</HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
          {visibleCampaigns.length === 0 && <TableBodyRow><DataCell colSpan={6}>No campaigns match this filter.</DataCell></TableBodyRow>}
          {visibleCampaigns.map((entry, index) => {
            return (
              <TableBodyRow key={entry.id} onClick={() => handleClick(entry)}>
                <DataCell>{entry.id}</DataCell>
                <DataCell>{entry.name}</DataCell>
                <DataCell>{resourceCreatorName(entry, user)}</DataCell>
                <DataCell>{entry.step_count}</DataCell>
                <DataCell>{entry.recipient_count}</DataCell>
                <DataCell>{entry.state === 0 ? 'draft' : (entry.state === 2 ? 'completed' : ((entry.last_sequence_number === 1 ? '1 step' : entry.last_sequence_number + ' steps') + ' done'))}</DataCell>
              </TableBodyRow>
            )
          })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  )
}

export default withRouter(CampaignTable)
